var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"purchase"},[_c('div',{staticClass:"nav-wrap"},[_c('Nav')],1),_c('div',{staticClass:"first-wrap"},[_c('first-screen')],1),_c('div',{staticClass:"footer-wrap"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }